import React from 'react';
import { HoverToolTip } from '../Items/HoverToolTip';
import { StopCircleIcon } from '../../../assets/CustomSvgs';

interface StopButtonProps {
  onStopStreaming: () => void;
}

export const StopButton: React.FC<StopButtonProps> = ({
  onStopStreaming,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onStopStreaming();
  };

  return (
    <button 
      type="button"
      onClick={handleClick}
      className="submit-button"
    >
      <StopCircleIcon />
      <HoverToolTip 
        text="Stop Message" 
        position="top" 
      />
    </button>
  );
};